import {cloneDeep, map} from "lodash";

import Category from "./filter/Category";
import React from "react";

const CategoriesContainer = React.memo(function CategoriesContainer({
    notFocusable,
    elements,
    getCategories,
    disabled,
    isUnique,
    isRadio,
    clickOff
}) {
    const handleClick = (index) => {
        if (getCategories) {
            let copy = cloneDeep(elements);
            if (isUnique) {
                copy = map(copy, (elem) => {
                    elem.clicked = false;
                    return elem;
                });
            }
            copy[index].clicked = !elements[index].clicked;
            getCategories(copy);
        }
    };

    return (<div
        style={{
            display: "contents", justifyContent: "center",
        }}
    >
        {elements?.map((category, index) => {
            return (<Category
                notFocusable={notFocusable}
                label={category.label}
                variant={category.variant}
                clicked={category.clicked}
                underline={category.clicked}
                lang={category.lang}
                disabled={disabled || category.disable}
                ariaLabel={category.ariaLabel}
                ariaDescribedBy={category.ariaDescribedBy}
                clickOff={clickOff !== undefined ? clickOff : category.clickOff}
                handleClick={() => {
                    if ((isRadio && category.clicked) || disabled) return;
                    handleClick(index);
                }}
                onKeyDown={() => {
                    if (!disabled && !category.clicked && !isRadio) handleClick(index);
                }}
                key={index}
                basecolor={category.disable ? "var(--light-grey-color)" : category.basecolor}
                disablePointer={category.disable ? {
                    pointerEvents: "none", cursor: "default"
                } : {}}
            />);
        })}
    </div>);
});

export default CategoriesContainer;
